export enum AnalyticsEvent {
  ViewArticle             = 'view-article',
  ViewArticleTopic        = 'view-article-topic',
  ViewPostAuthor          = 'view-post-author',
  ViewPostCommentAuthor   = 'view-post-comment-author',
  ViewPostTopic           = 'view-post-topic',
  ViewSuggestedTopic      = 'view-suggested-topic',
}